import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { SharedModule } from 'src/app/_metronic/shared/shared.module';

@Component({
  selector: 'app-auth-layout',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './auth-layout.component.html',
  styleUrls: ['./auth-layout.component.scss']
})
export class AuthLayoutComponent {
  @Input() isFullWidth: boolean = false;
  constructor() {}
}
